import * as _ from "lodash";
import {Pipe, PipeTransform} from "@angular/core";
import { SiniestralidadSiniestros, VehiculoSiniestros, CasaHabitacion, O2O, OtrosRamos } from "../../components/common/siniestros_entity";

@Pipe({
    name: "filterRamoSiniestros"
})
export class FilterRamoSiniestrosPipe implements PipeTransform {

    transform(array: SiniestralidadSiniestros[], query: string): any {
        if (query) {
            return _.filter(array, row=> ((row.Ramo+"").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}
@Pipe({
    name: "filterPolizaSiniestros"
})
export class FilterPolizaSiniestrosPipe implements PipeTransform {

    transform(array: SiniestralidadSiniestros[], query: string): any {
        if (query) {
            return _.filter(array, row=> ((row.Poliza+"").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}
@Pipe({
    name: "filterPlacaSiniestros"
})
export class FilterPlacaSiniestrosPipe implements PipeTransform {

    transform(array: VehiculoSiniestros[], query: string): any {
        if (query) {
            return _.filter(array, row=> ((row.Placa+"").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}
@Pipe({
    name: "filterDireccionSiniestros"
})
export class FilterDireccionSiniestrosPipe implements PipeTransform {

    transform(array: CasaHabitacion[], query: string): any {
        if (query) {
            return _.filter(array, row=> ((row.DireccionAfectada+"").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}
@Pipe({
    name: "filterPacienteSiniestros"
})
export class FilterPacienteSiniestrosPipe implements PipeTransform {

    transform(array: O2O[], query: string): any {
        if (query) {
            return _.filter(array, row=> ((row.NombrePaciente+"").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}
@Pipe({
    name: "filterDiagnosticoSiniestros"
})
export class FilterDiagnosticoSiniestrosPipe implements PipeTransform {

    transform(array: O2O[], query: string): any {
        if (query) {
            return _.filter(array, row=> ((row.Diagnostico+"").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}
@Pipe({
    name: "filterBienAfectadoOtrosRamos"
})
export class FilterBienAfectadoSiniestrosPipe implements PipeTransform {

    transform(array: OtrosRamos[], query: string): any {
        if (query) {
            return _.filter(array, row=> ((row.BienAfectado+"").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}
@Pipe({
    name: "filterTipoReclamoOtrosRamos"
})
export class FilterBTipoReclamoSiniestrosPipe implements PipeTransform {

    transform(array: OtrosRamos[], query: string): any {
        if (query) {
            return _.filter(array, row=> ((row.TipoReclamo+"").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}



@Pipe({
    name: "filterEstadoVehSiniestros"
})
export class FilterEstadoVehSiniestrosPipe implements PipeTransform {

    transform(array: VehiculoSiniestros[], query: string): any {
        if (query) {
            return _.filter(array, row=> ((row.Estado+"").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}
@Pipe({
    name: "filterEstadoCasSiniestros"
})
export class FilterEstadoCasSiniestrosPipe implements PipeTransform {

    transform(array: CasaHabitacion[], query: string): any {
        if (query) {
            return _.filter(array, row=> ((row.Estado+"").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}
@Pipe({
    name: "filterEstadoO2OSiniestros"
})
export class FilterEstadoO2OSiniestrosPipe implements PipeTransform {

    transform(array: O2O[], query: string): any {
        if (query) {
            return _.filter(array, row=> ((row.Estado+"").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}
@Pipe({
    name: "filterEstadoOtrosRamosSiniestros"
})
export class FilterEstadoOtrosRamosSiniestrosPipe implements PipeTransform {

    transform(array: OtrosRamos[], query: string): any {
        if (query) {
            return _.filter(array, row=> ((row.Estado+"").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/siniestros/siniestros-filter.component.ts